import type { SVGProps } from "react";
export interface FaceSleepingIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FaceSleepingIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FaceSleepingIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 12C.875 6.093 5.477 1.264 11.291.898l.116-.002a1.125 1.125 0 0 1 .027 2.246l-.432.038A8.877 8.877 0 0 0 12 20.875 8.875 8.875 0 0 0 20.876 12c0-1.095-.198-2.14-.559-3.106l2.108-.788c.454 1.213.7 2.526.7 3.894 0 6.144-4.98 11.125-11.123 11.125C5.856 23.125.875 18.144.875 12m20.102-4.555a1.125 1.125 0 0 1 1.447.661l-2.108.788a1.126 1.126 0 0 1 .661-1.449"
      />
      <path
        fill={color}
        d="M12 17.375a.125.125 0 0 0-.125.125l.01.05a.125.125 0 0 0 .23 0l.01-.05-.01-.049a.13.13 0 0 0-.066-.066l-.05-.01Zm-2.797-6.67a1.126 1.126 0 0 1 1.671 1.504l-.248.273c-1.205 1.195-3.047 1.195-4.251 0l-.25-.273-.067-.093a1.126 1.126 0 0 1 1.739-1.41l.078.086.143.146c.35.295.789.247 1.107-.146zm7 0a1.124 1.124 0 0 1 1.67 1.504l-.247.273c-1.205 1.195-3.048 1.195-4.253 0l-.247-.273-.067-.093a1.125 1.125 0 0 1 1.738-1.41l.076.086.144.146c.35.296.79.247 1.109-.146zm.297-7.33a1.125 1.125 0 0 1 .879 1.827l-.576.72a1.12 1.12 0 0 1-.188 2.197l-.115.006h-2a1.124 1.124 0 0 1-.879-1.827l.576-.72a1.12 1.12 0 0 1 .303-2.203zm5.5-2.5a1.125 1.125 0 0 1 .879 1.828l-.576.718a1.122 1.122 0 0 1-.187 2.199L22 5.625h-2a1.125 1.125 0 0 1-.879-1.828l.575-.72A1.12 1.12 0 0 1 18.876 2c0-.621.503-1.125 1.124-1.125zM14.125 17.5a2.126 2.126 0 0 1-4.24.218l-.01-.218.01-.217A2.125 2.125 0 0 1 12 15.375l.219.01a2.126 2.126 0 0 1 1.907 2.115Z"
      />
    </svg>
  );
}
